export enum LoanType {
    Construction = 1,
    Rental = 2,
    BuildRent = 3,
    Model = 4,
    Land = 5,
    FixFlip = 6,
    MasterNote = 7,
    SubNoteConstruction = 8,
    SubNoteFixFlip = 9,
    Bridge = 10,
}
